import { strategyToOptions } from '@/common/utils/strategyToOptions'

export enum SolicitationKind {
  PREVENTIVE = 'preventive',
  CORRECTIVE = 'corrective',
  FACTORY_WARRANTY = 'factory_warranty',
  EMERGENCY = 'emergency',
  PIECE_BUY = 'piece_buy',
  URGENCY = 'urgency',
  ASSISTANCE = 'assistance',
  PIECE_WARRANTY = 'piece_warranty',
  OIL_CHANGE = 'oil_change',
}

export const solicitationKindTranslation = {
  [SolicitationKind.PREVENTIVE]: 'Preventiva',
  [SolicitationKind.CORRECTIVE]: 'Corretiva',
  [SolicitationKind.FACTORY_WARRANTY]: 'Garantia de Fábrica',
  [SolicitationKind.EMERGENCY]: 'Emergência',
  [SolicitationKind.PIECE_BUY]: 'Compra de Peça',
  [SolicitationKind.URGENCY]: 'Urgência',
  [SolicitationKind.ASSISTANCE]: 'Assistência',
  [SolicitationKind.PIECE_WARRANTY]: 'Garantia de Peça',
  [SolicitationKind.OIL_CHANGE]: 'Troca de Óleo',
}

export const solicitationKindOptions = strategyToOptions(solicitationKindTranslation)
